export const COLORS = {
  ink: "#16191D",
  ink2: "#4A545F",
  ink3: "#7B8794",
  line: "#E5E7EA",
  line2: "#EEF0F2",
  page: "#F7F7F5",
  card: "#FFFFFF",
  brand: "#E08A12",
  brandBar: "#EFA02C",
  brandSoft: "#FDF3E3",
  blue: "#1B4FA8",
  blueSoft: "#E8EFFA",
  green: "#166B42",
  greenSoft: "#E4F1EA",
  amber: "#A2590A",
  amberSoft: "#FCF0DB",
  grey: "#68727E",
  greySoft: "#EFF1F3",
  red: "#A32D2D",
  redSoft: "#FBEBEB",
  violet: "#54388F",
  violetSoft: "#F1EBFA",
};

export const TONE: Record<string, string> = {
  grey: COLORS.grey,
  blue: COLORS.blue,
  amber: COLORS.amber,
  green: COLORS.green,
};

export const TONE_SOFT: Record<string, string> = {
  grey: COLORS.greySoft,
  blue: COLORS.blueSoft,
  amber: COLORS.amberSoft,
  green: COLORS.greenSoft,
};

export const STAGES: Array<"write" | "review" | "verify" | "approve"> = [
  "write",
  "review",
  "verify",
  "approve",
];
